import React, { useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { InputSearch } from 'components/form';
import { applyFilters } from 'pages/CaseManager/filters';
import { DotPulse } from 'components/loaders';

import {
  SearchBarStyled,
  ResultsDropdown,
  SearchLink,
  SearchLinkHead,
} from './styledComponents';

const Search = ({ rmaList = [], onSubmit, searchTerm, onChange, loading }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filteredResults, setFilteredResults] = useState([]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const results = value ? applyFilters({ items: rmaList, term: value }) : [];

    setIsDropdownOpen(results.length);
    setFilteredResults(results);
    onChange(value);
    if (!value) {
      onSubmit('');
    }
  };

  const handleInputFocus = (e) => {
    if (filteredResults.length) {
      setIsDropdownOpen(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDropdownOpen(false);
    onSubmit(searchTerm);
  };

  return (
    <ClickAwayListener onClickAway={() => setIsDropdownOpen(false)}>
      <SearchBarStyled>
        <form onSubmit={handleSubmit}>
          <InputSearch
            onAction={handleSubmit}
            inputProps={{
              placeholder: 'Search by Case #, RMA #, PO # and Serial #',
              value: searchTerm,
              onChange: handleInputChange,
              onFocus: handleInputFocus,
            }}
          />
        </form>
        {isDropdownOpen ? (
          <ResultsDropdown>
            <SearchLink to={{}} onClick={handleSubmit}>
              Show All Results...
              <FontAwesomeIcon icon={faChevronRight} />
            </SearchLink>
            {loading ? (
              <DotPulse />
            ) : (
              filteredResults.map((result) => (
                <SearchLink
                  key={result.id}
                  to={{
                    pathname: `/case/${result.caseNumber}`,
                  }}
                >
                  <SearchLinkHead>
                    <span>{result.caseNumber}</span>
                    {result.rmaNumber ? (
                      <span>ID {result.rmaNumber}</span>
                    ) : null}
                  </SearchLinkHead>
                  <div>
                    Created on{' '}
                    {new Date(result.createdDate).toLocaleDateString()} for{' '}
                    {result.contactName}
                  </div>
                  {result.poNumber ? (
                    <div>PO Number: {result.poNumber}</div>
                  ) : null}
                </SearchLink>
              ))
            )}
          </ResultsDropdown>
        ) : null}
      </SearchBarStyled>
    </ClickAwayListener>
  );
};

export { Search };
